<template>
  <div class="chats-view">
    <!-- Header-Bereich der Chat-Seite -->
    <aside class="chat-note" role="note" aria-live="header">
      <h2>Allgemeiner Austauschssraum</h2>
    </aside>
    <!-- Container für die eigentliche Chat-Komponente -->
    <div class="chatDiv">
          <!-- Die ChatView-Komponente wird hier eingebettet und erhält die Chat-ID als Prop. -->
          <ChatView :chatIdProp="chatID" :general="true" />
    </div>
    <!-- Footer-Bereich mit einem Hinweis -->
    <aside class="chat-note" role="note" aria-live="polite">
      <strong>Hinweis:</strong> Bitte verhalte dich freundlich und respektvoll im Chat. Wir speichern deine IP-Adresse!
    </aside>
  </div>
</template>

<script setup>
import ChatView from './ChatView.vue'
import { useRoute } from 'vue-router'

// Holt die aktuelle Route, um auf URL-Parameter zugreifen zu können.
const route = useRoute();

// Bestimmt die Chat-ID. Wenn ein ID-Parameter in der URL vorhanden ist, wird dieser verwendet,
// andernfalls wird der Standard-Chat "main" geladen.
const chatID = route?.params?.id ?? "main";

</script>

<style scoped lang="scss">
.chats-view {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  overflow: hidden;
  min-height: 0;
}
.chats-view h2 {
  padding: 0;
  margin: 0;
}
.chatDiv {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  min-height: 0;
  overflow: hidden;
}
.chat-note {
  background: rgba(255,255,255,0.03);
  color: inherit;
  padding: 0.65rem 1rem;
  margin: 0.5rem;
  border-radius: 10px;
  font-size: 0.9rem;
  border: 1px solid rgba(255,255,255,0.04);
  align-self: stretch;
}
</style>
